import { Avatar } from './avatar';
import { EntityTypes } from './enums/entityTypes';

export interface SupplierRequestMatch {
  requestId: string;
  matchId: string;
  orgId: string;
  entityType: EntityTypes.supplierMatch;
  orgName: string;
  naicsMatch: string;
  naicsMatchConfidence: number;
  primaryBusinessActivity?: string;
  primaryBusinessActivityConfidence?: number;
  productsAndServicesMatches?: string[];
  productsAndServicesHighestConfidence?: number;
  supplierMatchScore?: number;
  demographicDesignations?: string[];
  supplierRequirementsElements?: string[];
  matchScoreJustifications?: SRMatchScoreAndJustification[];
  coreRequirementJustifications?: SRMatchRequirementAndJustification[];
  qualifiedMatch?: boolean;
  avatar?: Avatar;
  created: number;
  lastUpdated: number;
}
export interface SRMatchScoreAndJustification {
  capability: string;
  canMeetCapability: boolean;
  justification: string;
  confidence: number;
}

export interface SRMatchRequirementAndJustification {
  requirement: string;
  canMeetRequirement: boolean;
  justification: string;
  confidence: number;
}
export interface CreateSupplierRequestMatchInput {
  requestId: string;
  orgId: string;
  orgName: string;
  naicsMatch: string;
  naicsMatchConfidence: number;
  primaryBusinessActivity?: string;
  primaryBusinessActivityConfidence?: number;
  productsAndServicesMatches?: string[];
  productsAndServicesHighestConfidence?: number;
  supplierMatchScore?: number;
  demographicDesignations?: string[];
  supplierRequirementsElements?: string[];
  matchScoreJustifications?: SRMatchScoreAndJustification[];
  coreRequirementJustifications?: SRMatchRequirementAndJustification[];
}

export interface UpdateSupplierRequestMatchScoreInput {
  matchId: string;
  supplierMatchScore?: number;
  supplierRequirementsElements?: string[];
  matchScoreJustifications?: SRMatchScoreAndJustification[];
  coreRequirementJustifications?: SRMatchRequirementAndJustification[];
  qualifiedMatch?: boolean;
}

export interface SRMatchScoreMessage {
  url: string;
  companyName: string;
  capabilities: string[];
  coreRequirements?: string[];
  matchId: string;
}

export interface SRMatchScorePublishedMessage {
  url: string;
  companyName: string;
  capabilities: SRMatchScoreAndJustification[];
  coreRequirements?: SRMatchRequirementAndJustification[];
  matchId: string;
  error?: boolean;
  errorMessage?: string;
}
